import { DefaultTheme } from "styled-components"

export const theme: DefaultTheme = {
  color: {
    baseBackground: "#091836",
    base: "#F3F3F3",
    special: "#D5A890",
    link: "#F33663"
  },
  settings: {
    small: { size: "1.6rem", line_height: "1.92" },
    medium: { size: "1.9rem", line_height: "2.28" },
    large: { size: "2.2rem", line_height: "2.64" }
  },
  breakpoints: {
    desktop: "45rem"
  }
}
